import { createFileRoute } from '@tanstack/react-router';
import { PartnerProgramPage } from '@/pages/partner/PartnerProgramPage';

export const Route = createFileRoute('/partner/program')({
  component: PartnerProgramPage
});
